import React from 'react'

function CriminalRecord() {
  return <div>CriminalRecord</div>
}

export default CriminalRecord
